<template>
	<div>
		<div>
			<h2>新升前端编码规范 v2.1 </h2><br>
			<hr><br>
		</div>
		<div style="padding-left: 80px;">
			<ol>
				<li>
					<h3> 推荐开启ESLint编码校验</h3><br>
				</li>
				<li>
					<h3> 目录、文件、组件命名</h3><br>
					<ul style="padding-left: 30px;">
						<li>全部采用小写方式， 以中划线分隔不使用骆驼(因为不用大写)。</li>
						正例：`category-tree-select`<br>
						反例：`category_tree-select / categoryTree-select`<br>
					</ul><br>
				</li>
				<li>
					<h3>单引号、双引号、分号</h3><br>
					<ul style="padding-left: 30px;">
						<li>html中、vue的template 中 标签属性 使用 双引号</li>
						<li>所有js中的 字符串 使用 单引号</li>
						<li>所有js中的代码行换行要用 分号</li><br>
					</ul>
				</li>

				<li>
					<h3>页面组件内的标签顺序</h3><br>
					<ul style="padding-left: 30px;">
						<li>单文件组件应该总是让标签顺序保持为 &lt;template&gt; 、&lt;script&gt;、&lt;style&gt; </li><br>
					</ul>
				</li>

				<li>
					<h3> Vue3 组合式 API规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>组件必须使用 setup 语法糖，setup 大法方便简洁，全局都要使用setup语法糖</li>
						<li> 组合式Composition API 规范</li>
						<div style="padding-left: 30px;">
							组件内必须使用模块化思想，把代码 进行 拆分；<br>
							参照 vue3官方文档对于 Composition Api的理解： 更灵活的代码组织 (opens new window)，组合式Api，即
							Composition API 解决的是让 相互关联的代码在一起，以更方便的组织代码，故我们的代码格式如下：<br> <br>

							&lt;script setup&gt;<br>
							// 各种需要导入<br>
							import xxxxx;<br>
							import xxxxx;<br>
							import xxxxx;<br>

							// -------- 1.定义组件属性和对外暴露的方法、以及抛出的事件 --------<br><br>

							// -------- 2.负责页面上要显示的数据: 表格查询的 变量和方法 --------<br><br>

							// -------- 3.负责页面逻辑计算: 批量操作的 变量和方法 --------<br><br>

							// -------- 4.表单的 变量和方法 --------<br><br>

							&lt;/script&gt;<br>

						</div><br>

					</ul>
				</li>

				<li>
					<h3> 模板引用变量Ref</h3><br>
					查询前缀：<br>

					<ul style="padding-left: 30px;">
						<li> 对于vue3中的模板引用ref，即 ref 是作为一个特殊的 attribute </li>
						如: &lt;input ref="inputRef"&gt; <br>
						<li>新升代码规范要求：</li>
						使用 ref方法，参数为空 进行声明变量<br>
						变量必须以 Ref为结尾<br>
						template中的ref 也必须以 Ref 为结尾<br>
						比如上面的例子，我们声明如下:<br>
						&nbsp;&nbsp;&nbsp;&nbsp; const inputRef = ref();<br>
					</ul>
					<br>

				</li>

				<li>
					<h3> 变量和方法的注释</h3><br>

					<ul style="padding-left: 30px;">
						<li> 在使用Composition Api进行代码编写时，我们有效的组织了代码，但是由于Composition Api变量和方法会写到一起，这时候注释就变得很有必要
							要求:</li>
						1、变量必须都加上注释 <br> 2、方法必须加上注释 <br>
						<div style="padding-left: 30px;">
							例如<br><br>

							// 查询 公告 默认值<br>
							const queryFormState = {<br>
							&nbsp;&nbsp;noticeTypeId: undefined, &nbsp;&nbsp;&nbsp;&nbsp;//分类<br>
							&nbsp;&nbsp;keywords: '', &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;//标题、作者、来源<br>
							&nbsp;&nbsp;documentNumber: '', &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;//文号<br>
							&nbsp;&nbsp;createUserId: undefined, &nbsp;&nbsp;&nbsp;&nbsp;//创建人<br>
							&nbsp;&nbsp;deletedFlag: undefined, &nbsp;&nbsp;&nbsp;&nbsp;//删除标识<br>
							&nbsp;&nbsp;createTimeBegin: null, &nbsp;&nbsp;&nbsp;&nbsp;//创建-开始时间<br>
							&nbsp;&nbsp;createTimeEnd: null, &nbsp;&nbsp;&nbsp;&nbsp;//创建-截止时间<br>
							&nbsp;&nbsp;publishTimeBegin: null, &nbsp;&nbsp;&nbsp;&nbsp;//发布-开始时间<br>
							&nbsp;&nbsp;publishTimeEnd: null, &nbsp;&nbsp;&nbsp;&nbsp;//发布-截止时间<br>
							&nbsp;&nbsp;pageNum: 1,<br>
							&nbsp;&nbsp;pageSize: PAGE_SIZE,<br>
							};<br><br>

							// 查询 公告 请求表单<br>
							&nbsp;&nbsp;const queryForm = reactive({ ...queryFormState });<br>

						</div>
					</ul>
					<br>

				</li>

				<li>
					<h3> Vue 目录规范</h3><br>


					<div style="padding-left: 30px;">
						<ul style="padding-left: 30px;">
							<li> src 源码目录</li>
							<div style="padding-left: 30px;">
								|-- api 所有api接口<br>
								|-- assets 静态资源，images, icons, styles等<br>
								|-- components 公用组件<br>
								|-- config 配置信息<br>
								|-- constants 常量信息，项目所有Enum, 全局常量等<br>
								|-- directives 自定义指令<br>
								|-- i18n 国际化<br>
								|-- lib 外部引用的插件存放及修改文件<br>
								|-- mock 模拟接口，临时存放<br>
								|-- plugins 插件，全局使用<br>
								|-- router 路由，统一管理<br>
								|-- store vuex, 统一管理<br>
								|-- theme 自定义样式主题<br>
								|-- utils 工具类<br>
								|-- views 视图目录<br>
								| |-- role role模块名<br>
								| |-- |-- list.vue role列表页面<br>
								| |-- |-- add.vue role新建页面<br>
								| |-- |-- update.vue role更新页面<br>
								| |-- |-- index.less role模块样式<br>
								| |-- |-- components role模块通用组件文件夹<br>
								| |-- employee employee模块<br>
							</div>

							<li> api 目录</li>
							<div style="padding-left: 30px;">
								<p>pi文件要以api为结尾，比如 employee-api.js、login-api.js，方便查找
									api文件必须导出对象必须以Api为结尾，如：employeeApi、noticeApi</p>
								例如前端 department-api.js中:<br><br>
								import { getRequest, postRequest } from '/@/lib/axios';<br><br>

								export const departmentApi = {<br>
									&nbsp;&nbsp;/**<br>
									&nbsp;&nbsp;* @description: 查询部门列表 @author Rick<br>
									&nbsp;&nbsp;* @param {*}<br>
									&nbsp;&nbsp;* @return {*}<br>
									&nbsp;&nbsp;*/<br>
									&nbsp;&nbsp;queryAllDepartment: () => {<br>
										&nbsp;&nbsp;&nbsp;&nbsp;return getRequest('/department/listAll');<br>
										&nbsp;&nbsp;},<br>
										&nbsp;&nbsp;...<br>
							</div>
						</ul>
					</div>
				</li>

				 
			</ol>

			<br>



		</div>
	</div>
</template>

<script>

export default {
	name: 'dev-front',
	data() {
		return {


		};
	},

	methods: {

	},
	mounted() {

	}
};
</script>

<style lang="scss" scoped="scoped"></style>
